<template lang="pug">
.product-page
	.text-center.mb-3
		.main-title.mb-1.mb-lg-5 {{$t('ui.slot_games')}}
	.row
		.col-6.col-lg-4.px-0.px-lg-1(v-if="getKkStatus===true")
			.product-wrap
				router-link(to="kingkong")
					.product-single
						.product-pic
							img.w-100.img-fluid(src='img/slot/kingkong688.png')
						.product-hover
							img.w-100.img-fluid(src='img/slot/kingkong688_hover.png')
		.col-6.col-lg-4.px-0.px-lg-1(v-if="getNkStatus===true")
			.product-wrap
				router-link(:to="{name: 'pragmatic', params: {game: 'pragmatic'}}")
					.product-single
						.product-pic
							img.w-100.img-fluid(src='img/slot/pragmatic-play.png')
						.product-hover
							img.w-100.img-fluid(src='img/slot/pragmatic-play-hover.png')
		.col-6.col-lg-4.px-0.px-lg-1(v-if="getLive22Status===true")
			.product-wrap
				router-link(to="live22")
					.product-single
						.product-pic
							img.w-100.img-fluid(src='img/slot/live22.png')
						.product-hover
							img.w-100.img-fluid(src='img/slot/live22-hover.png')
		//- .col-6.col-lg-4.px-0.px-lg-1
		//- 	.product-wrap
		//- 		router-link(to="peg")
		//- 			.product-single
		//- 				.product-pic
		//- 					img.w-100.img-fluid(src='img/slot/pegasus.png')
		//- 				.product-hover
		//- 					img.w-100.img-fluid(src='img/slot/pegasus_hover.png')
		//- .col-6.col-lg-4.px-0.px-lg-1
			.product-wrap
				router-link(to="uuslot")
					.product-single
						.product-pic
							img.w-100.img-fluid(src='img/slot/uu.png')
						.product-hover
							img.w-100.img-fluid(src='img/slot/uu_hover.png')
		//- .col-6.col-lg-4.px-0.px-lg-1
			.product-wrap
				a(href='#')
					.product-single
						.product-pic
							img.w-100.img-fluid(src='img/slot/pg-soft.png')
						.product-hover
							img.w-100.img-fluid(src='img/slot/pg-soft-hover.png')
		//- .col-6.col-lg-4.px-0.px-lg-1
			.product-wrap
				a(href='#')
					.product-single
						.product-pic
							img.w-100.img-fluid(src='img/slot/jili.png')
						.product-hover
							img.w-100.img-fluid(src='img/slot/jili-hover.png')
		//- .col-6.col-lg-4.px-0.px-lg-1
			.product-wrap
				a(href='#')
					.product-single
						.product-pic
							img.w-100.img-fluid(src='img/slot/spadegaming.png')
						.product-hover
							img.w-100.img-fluid(src='img/slot/spadegaming-hover.png')
		//- .col-6.col-lg-4.px-0.px-lg-1
			.product-wrap
				a(href='#')
					.product-single
						.product-pic
							img.w-100.img-fluid(src='img/slot/jdb.png')
						.product-hover
							img.w-100.img-fluid(src='img/slot/jdb-hover.png')
		//- .col-6.col-lg-4.px-0.px-lg-1
			.product-wrap
				a(href='#')
					.product-single
						.product-pic
							img.w-100.img-fluid(src='img/slot/skywind.png')
						.product-hover
							img.w-100.img-fluid(src='img/slot/skywind-hover.png')
		.col-6.col-lg-4.px-0.px-lg-1(v-if="getNkStatus===true")
			.product-wrap
				router-link(:to="{name: 'rubyplay', params: {game: 'rubyplay'}}")
					.product-single
						.product-pic
							img.w-100.img-fluid(src='img/slot/rubyplay.png')
						.product-hover
							img.w-100.img-fluid(src='img/slot/rubyplay_hover.png')
		.col-6.col-lg-4.px-0.px-lg-1(v-if="getNkStatus===true")
			.product-wrap
				router-link(:to="{name: 'amatic', params: {game: 'amatic'}}")
					.product-single
						.product-pic
							img.w-100.img-fluid(src='img/slot/amatic.png')
						.product-hover
							img.w-100.img-fluid(src='img/slot/amatic_hover.png')
		.col-6.col-lg-4.px-0.px-lg-1(v-if="getNkStatus===true")
			.product-wrap
				router-link(:to="{name: 'scientificgames', params: {game: 'scientific_games'}}")
					.product-single
						.product-pic
							img.w-100.img-fluid(src='img/slot/scientific-games.png')
						.product-hover
							img.w-100.img-fluid(src='img/slot/scientific-games_hover.png')
		.col-6.col-lg-4.px-0.px-lg-1(v-if="getNkStatus===true")
			.product-wrap
				router-link(:to="{name: 'vegas', params: {game: 'vegas'}}")
					.product-single
						.product-pic
							img.w-100.img-fluid(src='img/slot/vegas.png')
						.product-hover
							img.w-100.img-fluid(src='img/slot/vegas_hover.png')
		.col-6.col-lg-4.px-0.px-lg-1(v-if="getNkStatus===true")
			.product-wrap
				router-link(:to="{name: 'novomatic', params: {game: 'novomatic'}}")
					.product-single
						.product-pic
							img.w-100.img-fluid(src='img/slot/novomatic.png')
						.product-hover
							img.w-100.img-fluid(src='img/slot/novomatic_hover.png')
		.col-6.col-lg-4.px-0.px-lg-1(v-if="getNkStatus===true")
			.product-wrap
				router-link(:to="{name: 'microgaming', params: {game: 'microgaming'}}")
					.product-single
						.product-pic
							img.w-100.img-fluid(src='img/slot/microgaming.png')
						.product-hover
							img.w-100.img-fluid(src='img/slot/microgaming_hover.png')
		.col-6.col-lg-4.px-0.px-lg-1(v-if="getNkStatus===true")
			.product-wrap
				router-link(:to="{name: 'ainsworth', params: {game: 'ainsworth'}}")
					.product-single
						.product-pic
							img.w-100.img-fluid(src='img/slot/ainsworth.png')
						.product-hover
							img.w-100.img-fluid(src='img/slot/ainsworth_hover.png')
		.col-6.col-lg-4.px-0.px-lg-1(v-if="getNkStatus===true")
			.product-wrap
				router-link(:to="{name: 'quickspin', params: {game: 'quickspin'}}")
					.product-single
						.product-pic
							img.w-100.img-fluid(src='img/slot/quickspin.png')
						.product-hover
							img.w-100.img-fluid(src='img/slot/quickspin_hover.png')
		.col-6.col-lg-4.px-0.px-lg-1(v-if="getNkStatus===true")
			.product-wrap
				router-link(:to="{name: 'apollo', params: {game: 'apollo'}}")
					.product-single
						.product-pic
							img.w-100.img-fluid(src='img/slot/apollo.png')
						.product-hover
							img.w-100.img-fluid(src='img/slot/apollo_hover.png')
		.col-6.col-lg-4.px-0.px-lg-1(v-if="getNkStatus===true")
			.product-wrap
				router-link(:to="{name: 'NetEnt', params: {game: 'NetEnt'}}")
					.product-single
						.product-pic
							img.w-100.img-fluid(src='img/slot/NetEnt.png')
						.product-hover
							img.w-100.img-fluid(src='img/slot/NetEnt_hover.png')
		.col-6.col-lg-4.px-0.px-lg-1(v-if="getNkStatus===true")
			.product-wrap
				router-link(:to="{name: 'igt', params: {game: 'igt'}}")
					.product-single
						.product-pic
							img.w-100.img-fluid(src='img/slot/igt.png')
						.product-hover
							img.w-100.img-fluid(src='img/slot/igt_hover.png')
		.col-6.col-lg-4.px-0.px-lg-1(v-if="getNkStatus===true")
			.product-wrap
				router-link(:to="{name: 'aristocrat', params: {game: 'aristocrat'}}")
					.product-single
						.product-pic
							img.w-100.img-fluid(src='img/slot/aristocrat.png')
						.product-hover
							img.w-100.img-fluid(src='img/slot/aristocrat_hover.png')
		.col-6.col-lg-4.px-0.px-lg-1(v-if="getNkStatus===true")
			.product-wrap
				router-link(:to="{name: 'igrosoft', params: {game: 'igrosoft'}}")
					.product-single
						.product-pic
							img.w-100.img-fluid(src='img/slot/igrosoft.png')
						.product-hover
							img.w-100.img-fluid(src='img/slot/igrosoft_hover.png')
		.col-6.col-lg-4.px-0.px-lg-1(v-if="getNkStatus===true")
			.product-wrap
				router-link(:to="{name: 'apex', params: {game: 'apex'}}")
					.product-single
						.product-pic
							img.w-100.img-fluid(src='img/slot/apex.png')
						.product-hover
							img.w-100.img-fluid(src='img/slot/apex_hover.png')
		.col-6.col-lg-4.px-0.px-lg-1(v-if="getNkStatus===true")
			.product-wrap
				router-link(:to="{name: 'gclub', params: {game: 'gclub'}}")
					.product-single
						.product-pic
							img.w-100.img-fluid(src='img/slot/gclub.png')
						.product-hover
							img.w-100.img-fluid(src='img/slot/gclub_hover.png')
		.col-6.col-lg-4.px-0.px-lg-1(v-if="getNkStatus===true")
			.product-wrap
				router-link(:to="{name: 'wazdan', params: {game: 'wazdan'}}")
					.product-single
						.product-pic
							img.w-100.img-fluid(src='img/slot/wazdan.png')
						.product-hover
							img.w-100.img-fluid(src='img/slot/wazdan_hover.png')
		.col-6.col-lg-4.px-0.px-lg-1(v-if="getNkStatus===true")
			.product-wrap
				router-link(:to="{name: 'egt', params: {game: 'egt'}}")
					.product-single
						.product-pic
							img.w-100.img-fluid(src='img/slot/egt.png')
						.product-hover
							img.w-100.img-fluid(src='img/slot/egt_hover.png')
</template>
<script>
import _ from "lodash";
export default {
	components:{
	},
	data(){
		return{
			feedback: {
        success: true,
        status: ""
      },
			providerSelected: 0,
		}
	},
	computed: {
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
		getKkStatus(){
			return this.$store.state.user.account.kk
		},
		getLive22Status(){
			return this.$store.state.user.account.live22
		},
		// getLgStatus(){
		// 	return this.$store.state.user.account.lg
		// },
		getNkStatus(){
			return this.$store.state.user.account.nk
		},
		// getSlotSelected(){
		// 	return this.$store.getters.slotSelected
		// }
  },
	// watch:{
	// 	getSlotSelected(newState, oldState){
	// 		this.providerSelected = newState
	// 	}
	// },
	// beforeDestroy(){
	// 	this.$store.dispatch("user/setSlotSelected", 0)
	// },
	created(){
		if(this.getKkStatus===false && this.getLive22Status===false && this.getNkStatus===false){
			this.$router.push("/").catch(error =>{})
		}
	},
  mounted(){
		window.scroll(0,0)
		// if(!_.isEmpty(this.$route.params)){
    //   if(this.$route.params.provider){
		// 		this.providerSelected = this.$route.params.provider
		// 	}
    // }
		// this.getRtplist()
		// this.providerSelected = this.getSlotSelected
  },
	methods:{
		// changeProvider(option){
		// 	if(option === this.providerSelected){
		// 		return
		// 	}else{
		// 		this.providerSelected = option
		// 		this.$store.dispatch("user/setSlotSelected", option)
		// 	}
		// },
	// 	getRtplist(){
	// 		this.$store
	// 			.dispatch("user/getRtplist", { })
	// 			.then(response => {
	// 				if (response.success == true) {
	// 					this.rtpList = response.data.value;
	// 					console.log(this.rtpList)
	// 				} else {
	// 					if((typeof response.status) != 'object'){
	// 						this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
	// 					}
	// 				}
	// 			})
	// 			.catch(response => {
	// 				if((typeof response.status) != 'object'){
	// 					this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
	// 				}
	// 			});
	// 	}
	}
}
</script>
<style lang="scss" scoped>
.active{
	border: 1px solid #8127C5;
}
</style>